// src/models/consultation/clinicalBookingInvalidated.ts
const CLINICAL_BOOKING_INVALIDATED_CODE = "clinical_booking_invalidated";
function clinicalBookingInvalidatedDetails(args) {
	return {
		code: CLINICAL_BOOKING_INVALIDATED_CODE,
		reason: args.reason,
		...args.consultationId ? { consultationId: args.consultationId } : {}
	};
}

export { CLINICAL_BOOKING_INVALIDATED_CODE, clinicalBookingInvalidatedDetails };
//# sourceMappingURL=clinicalBookingInvalidated.mjs.map